import { PresetterMode, PRESETTER_MODES } from '../utils/constants';

interface BinaryOutputGridProps {
  mode: PresetterMode;
  bytes: [string, string, string, string];
}

export function BinaryOutputGrid({ mode, bytes }: BinaryOutputGridProps) {
  const dParams = PRESETTER_MODES[mode].dParams;

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr>
            <th className="px-2 py-1 text-left text-sm font-medium text-gray-600 dark:text-gray-400 w-20">
              D-Param
            </th>
            {[7, 6, 5, 4, 3, 2, 1, 0].map(bit => (
              <th
                key={bit}
                className="px-1 py-1 text-center text-xs font-medium text-gray-500 dark:text-gray-400 w-10"
              >
                {bit}
              </th>
            ))}
            <th className="px-2 py-1 text-center text-sm font-medium text-gray-600 dark:text-gray-400 w-16">
              Hex
            </th>
          </tr>
        </thead>
        <tbody>
          {bytes.map((byte, byteIndex) => (
            <tr key={byteIndex} className="border-t border-gray-200 dark:border-gray-700">
              <td className="px-2 py-2 font-mono text-sm font-medium text-green-600 dark:text-green-400">
                {dParams[byteIndex]}
              </td>
              {byte.split('').map((bit, bitIndex) => (
                <td key={bitIndex} className="px-1 py-2">
                  <div
                    className={`
                      w-8 h-8 flex items-center justify-center font-mono text-lg rounded border-2
                      ${bit === '1'
                        ? 'bg-green-100 dark:bg-green-900 border-green-400 dark:border-green-600 text-green-800 dark:text-green-200'
                        : 'bg-gray-50 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300'
                      }
                    `}
                  >
                    {bit}
                  </div>
                </td>
              ))}
              <td className="px-2 py-2 font-mono text-sm text-gray-600 dark:text-gray-400 text-center">
                {parseInt(byte, 2).toString(16).toUpperCase().padStart(2, '0')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
